import { HttpHandler } from 'msw'

import { saleReports } from './sale'
import { serviceReports } from './service'
import { stockReports } from './stock'
import { vatReports } from './vat'

export const reports: HttpHandler[] = [
    ...saleReports,
    ...serviceReports,
    ...stockReports,
    ...vatReports,
]
